'use es6';

import ActionTypes from '../actions/ActionTypes';
import Lesson from 'academy-shared-js/records/Lesson';
import { Map as ImmutableMap, fromJS } from 'immutable';
import { flattenRecommendations } from '../utils/utils';
const tracksFromStorage = {
  lessonsById: {}
};
const INITIAL_STATE = ImmutableMap({
  isRequesting: false,
  isRequestingSearch: false,
  isRequestingPartner: false,
  lastValidResult: 0,
  hasError: false,
  totalCount: 0,
  recentError: undefined,
  lessonsById: ImmutableMap(tracksFromStorage.lessonsById).map(lessonObj => Lesson(fromJS(lessonObj))),
  recommendedLessons: ImmutableMap({
    bySeedLessonId: ImmutableMap(),
    hasError: false,
    isRequesting: false,
    recentError: undefined
  })
});

function getGradedValue(oldLesson, newLesson) {
  const newValue = newLesson.get('graded');

  if (!oldLesson) {
    return newValue;
  }

  return typeof newValue !== 'boolean' ? oldLesson.get('graded') : newValue;
}

function handleLessonByIdUpdate(state, action) {
  switch (action.type) {
    case ActionTypes.GET_LESSON_BY_ID_REQUESTING:
      {
        if (state) {
          return state.merge({
            isRequesting: true,
            id: action.meta
          });
        }

        return ImmutableMap({
          isRequesting: true,
          id: action.meta
        });
      }

    case ActionTypes.GET_LESSON_BY_ID_RECEIVE:
      {
        return state.mergeDeep(action.payload.lesson.merge({
          lastValidResult: Date.now(),
          // todo: kill this with fire as part of #issues/1024
          graded: getGradedValue(state, action.payload.lesson)
        }));
      }

    case ActionTypes.GET_LESSON_BY_ID_ERROR:
      {
        return state.mergeDeep(ImmutableMap({
          isRequesting: false,
          hasError: true,
          recentError: action.payload
        }));
      }

    default:
      return state;
  }
}

function getLessonsByIdWithMostUpToDateLessons(currentLessonsById, action) {
  const actionComesWithTimestamp = action.meta ? !!action.meta.timestamp : false;
  const newLessonsById = action.payload.lessonsById.map(lesson => {
    const maybeExistingLesson = currentLessonsById.get(lesson.get('id'));
    const gradedValue = getGradedValue(maybeExistingLesson, lesson);

    if (!maybeExistingLesson || !actionComesWithTimestamp) {
      // if we don't currently have a lesson, or we don't know the timestamp, so
      // let's use the lesson from the action since we can't be sure
      // what the most up-to-date lesson is.
      return lesson.merge({
        lastValidResult: actionComesWithTimestamp ? action.meta.timestamp : Date.now(),
        // todo: kill this with fire as part of #issues/1024
        graded: gradedValue
      });
    }

    if (action.meta.timestamp > maybeExistingLesson.get('lastValidResult')) {
      // this lesson is more up to date than the lesson in the store. Replace with the new lesson.
      return lesson.merge({
        lastValidResult: action.meta.timestamp,
        // todo: kill this with fire as part of #issues/1024
        graded: gradedValue
      });
    } // otherwise, let's just update the graded value of the current lesson


    return maybeExistingLesson.merge({
      graded: gradedValue
    });
  });
  return currentLessonsById.merge(newLessonsById);
}

function handleReceiveLessons(state, action) {
  const newLessonsByIdMap = getLessonsByIdWithMostUpToDateLessons(state.get('lessonsById'), action);

  switch (action.type) {
    case ActionTypes.TRACK_BY_ID_RECEIVE:
    case ActionTypes.TRACKS_RECEIVED:
      return state.merge({
        lessonsById: newLessonsByIdMap
      });

    default:
      return state;
  }
}

export default function Lessons(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_LESSONS_BY_ID_RECEIVE:
      return state.mergeDeep({
        lessonsById: action.payload.lessonsById,
        isRequesting: !action.meta.isPartner ? false : state.get('isRequesting'),
        isRequestingPartner: action.meta.isPartner ? false : state.get('isRequestingPartner')
      });

    case ActionTypes.GET_LESSON_BY_ID_REQUESTING:
    case ActionTypes.GET_LESSON_BY_ID_RECEIVE:
    case ActionTypes.GET_LESSON_BY_ID_ERROR:
      return state.setIn(['lessonsById', action.meta], handleLessonByIdUpdate(state.getIn(['lessonsById', action.meta]), action));

    case ActionTypes.GET_LESSONS_REQUESTING:
      return state.merge({
        isRequesting: !action.meta.isPartner ? true : state.get('isRequesting'),
        isRequestingPartner: action.meta.isPartner ? true : state.get('isRequestingPartner')
      });

    case ActionTypes.TRACK_BY_ID_RECEIVE:
    case ActionTypes.TRACKS_RECEIVED:
      return handleReceiveLessons(state, action);

    case ActionTypes.GET_LESSONS_ERROR:
      return state.merge({
        isRequesting: false,
        hasError: true,
        recentError: action.payload
      });

    case ActionTypes.GET_RECOMMENDED_LESSONS_REQUESTING:
      return state.mergeIn(['recommendedLessons'], {
        hasError: false,
        isRequesting: true
      });

    case ActionTypes.GET_RECOMMENDED_LESSONS_ERROR:
      return state.mergeIn(['recommendedLessons'], {
        isRequesting: false,
        hasError: true,
        recentError: action.payload
      });

    case ActionTypes.GET_RECOMMENDED_LESSONS_RECEIVED:
      return state.mergeIn(['recommendedLessons'], {
        hasError: false,
        isRequesting: false
      }).setIn(['recommendedLessons', 'bySeedLessonId', action.payload.seedLessonId], flattenRecommendations(action.payload.recommendations));

    default:
      return state;
  }
}